<template>
    <div class="navBar-box">
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="left-box">
                <router-link class="navbar-brand" to="/">
                    <div class="logo-box" v-show="!isNav2">
                        <img class="logo" src="https://image.szshuwei.com/FrdB9fN-Z12wkn8Pe5T6Ij91Qd6R" />
                    </div>
                    <div class="logo-box" v-show="isNav2">
                        <img class="logo" src="https://image.szshuwei.com/FqtpS4iYR8gsEYVMRbJNVFuPMJje" />
                    </div>
                </router-link>
            </div>
            <button
                class="navbar-toggler"
                type="button"
                data-toggle="collapse"
                data-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
            >
                <span class="iconfont icon-caidan"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <div></div>
                <div class="center-box">
                    <ul class="navbar-nav">
                        <li class="nav-item">
                            <router-link class="nav-link" :class="{ active: activeIndex === 0 }" to="/">首页</router-link>
                        </li>
                        <!-- <li class="nav-item dropdown">
                            <router-link class="nav-link dropdown-toggle" to="" role="button" data-toggle="dropdown" aria-expanded="false">
                                开店数字化
                                <span class="arrow"></span>
                            </router-link>
                            <div class="dropdown-menu">
                                <router-link class="dropdown-item" :target="$store.state.token ? '_self' : '_blank'" :to="{ name: 'superiorStaffHome' }">上上参谋</router-link>
                                <router-link class="dropdown-item" :target="$store.state.token ? '_self' : '_blank'" :to="{ name: 'cloudHome' }">上上参谋企业版</router-link>
                            </div>
                        </li>
                        <li class="nav-item dropdown">
                            <router-link class="nav-link dropdown-toggle" to="" role="button" data-toggle="dropdown" aria-expanded="false">
                                数据服务
                                <span class="arrow"></span>
                            </router-link>
                            <div class="dropdown-menu">
                                <router-link class="dropdown-item" :to="{ name: 'Gather' }">数位数采</router-link>
                                <a class="dropdown-item" href="https://www.swguancha.com">数位观察</a>
                            </div>
                        </li> -->
                        <li class="nav-item dropdown">
                            <router-link class="nav-link dropdown-toggle" to="" role="button" data-toggle="dropdown" aria-expanded="false">
                                产品与服务
                                <span class="arrow"></span>
                            </router-link>
                            <div class="dropdown-menu">
                                <router-link class="dropdown-item" :target="$store.state.token ? '_self' : '_blank'" :to="{ name: 'superiorStaffHome' }">上上参谋</router-link>
                                <router-link class="dropdown-item" :target="$store.state.token ? '_self' : '_blank'" :to="{ name: 'cloudHome' }">上上参谋企业版</router-link>
                                <!-- <router-link class="dropdown-item" :to="{ name: 'Gather' }">数位数采</router-link> -->
                                <a class="dropdown-item" href="https://www.swguancha.com">数位观察</a>
                            </div>
                        </li>
                        <li class="nav-item">
                            <router-link class="nav-link" :class="{ active: activeIndex === 2 }" :to="{ name: 'News' }">资讯中心</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link class="nav-link" :class="{ active: activeIndex === 3 }" :to="{ name: 'about' }">关于我们</router-link>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    </div>
</template>

<script>
export default {
    name: '',
    data() {
        return {
            isAdmin: false, // 是否从管理后台跳转过来
            activeIndex: 0 //首页
        };
    },
    props: {
        isNav2: {
            type: Boolean,
            default: false
        }
    },
    mounted() {
        // 判断当前路由
        if (this.$route.path === '/') {
            this.activeIndex = 0;
        } else if (this.$route.path === '/news') {
            this.activeIndex = 2;
        } else if (this.$route.path === '/about') {
            this.activeIndex = 3;
        }
    }
};
</script>

<style scoped lang="less">
.navBar-box {
    position: fixed;
    z-index: 999;
    width: 100%;
    height: 79px;
    background: rgba(#0f1016, 0.5);

    .navbar {
        // width: 100%;
        height: 100%;
        margin: 0 10%;
        font-size: 15px;
        color: #fff;
        justify-content: space-between;

        .nav-link {
            display: inline-flex;
            align-items: center;
            color: #fff;
            letter-spacing: 1px;
            font-size: 16px;
            text-align: left;
            .arrow {
                margin-left: 8px;
                width: 10px;
                height: 10px;
                background: url(../assets/images/arrow-down.svg) no-repeat center / contain;
            }
        }

        .left-box {
            .logo-box {
                display: inline-flex;
                align-items: center;
            }
            .logo-icon {
                width: auto;
                height: 41px;
                margin-left: 15px;
                object-fit: scale-down;
                @media @max-md {
                    height: 30px;
                }
            }

            .logo {
                width: auto;
                height: 38px;
                margin-left: 15px;
                object-fit: scale-down;
                @media @max-md {
                    height: 30px;
                }
                @media @max-sm {
                    margin-left: 0;
                }
            }
        }

        .navbar-toggler {
            .icon-caidan {
                color: #fff;
                font-size: 22px;
            }
        }

        .collapse {
            // display: flex;
            justify-content: space-between;
            // align-items: center;
            // flex-wrap: wrap;
        }

        .collapse:not(.show) {
            display: none;
        }

        .center-box {
            // display: flex;
            // align-items: center;

            .nav-item {
                margin-right: 54px;
                @media @max-lg {
                    margin-right: 20px;
                }
                @media @max-md {
                    margin-right: 0px;
                }
            }
            .active {
                color: #eb5405;
            }
            .nav-link {
                .arrow-down {
                    font-size: 16px;
                    margin-left: 6px;
                }
            }

            .dropdown-toggle::after {
                display: none;
            }
        }

        .right-box {
            padding-right: 25px;
            display: flex;
            align-items: center;

            .query-icon {
                font-size: 24px;
                margin-right: 22px;
            }

            .el-dropdown-link {
                color: #fff;
                display: flex;
                align-items: center;

                .text {
                    margin: 0 5px;
                }

                .el-icon-caret-bottom {
                    color: #888788;
                    font-size: 13px;
                }
            }
        }
    }
}

.dropdown.show {
    .arrow {
        transform: rotate(180deg);
    }
}
.dropdown-item {
    padding: 15px;
    transition: all 0.3s;
    text-align: center;
}
.dropdown-item:focus,
.dropdown-item:hover {
    text-decoration: none;
    background-color: #eb5405;
    color: #fff;
}
</style>
